import {Component, Input, OnInit} from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import {FileService} from "../../../../services/file.service";
import {NotificationService} from "../../../../services/notification.service";

@Component({
    selector: 'app-pdf-password-modal',
    templateUrl: './pdf-password-modal.component.html',
    styleUrls: ['./pdf-password-modal.component.scss'],
    standalone: false
})
export class PdfPasswordModalComponent implements OnInit {
  @Input() file: File;
  password: string = '';


  constructor(public activeModal: NgbActiveModal,
    private readonly _fileService: FileService,
    private readonly _notificationService: NotificationService,) { }

  ngOnInit(): void {}

  closeModal(): void {
    this.activeModal.dismiss(); // Close the modal without returning anything
  }

  submitPassword(): void {
    if (!this.password) {
      return;
    }

    this.activeModal.close(this.password);
  }
}
